import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Eye, EyeOff } from "lucide-react";

export default function Register() {
  const { register, loginWithGoogle } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", phone: "", password: "" });
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const res = await register(form);
    setLoading(false);
    if (res.ok) { toast.success("Account created!"); const next = new URLSearchParams(window.location.search).get("next"); navigate(next || "/"); }
    else toast.error(res.error);
  };

  return (
    <div className="max-w-md mx-auto px-4 py-20">
      <div className="bg-[#12141a] border border-zinc-800 rounded-2xl p-8">
        <h1 className="font-display text-3xl font-extrabold text-white">Create account</h1>
        <p className="text-zinc-400 text-sm mt-1">Track orders and reorder gang sheets in one click.</p>
        <form onSubmit={submit} className="space-y-4 mt-6">
          <div><Label className="text-zinc-300">Full name</Label>
            <Input data-testid="register-name" required value={form.name} onChange={set("name")} className="mt-1.5 bg-[#1e222d] border-zinc-700 text-white focus:border-[#ff6a13] focus:ring-[#ff6a13]" /></div>
          <div><Label className="text-zinc-300">Email</Label>
            <Input data-testid="register-email" type="email" required value={form.email} onChange={set("email")} className="mt-1.5 bg-[#1e222d] border-zinc-700 text-white focus:border-[#ff6a13] focus:ring-[#ff6a13]" /></div>
          <div><Label className="text-zinc-300">Phone</Label>
            <Input data-testid="register-phone" value={form.phone} onChange={set("phone")} className="mt-1.5 bg-[#1e222d] border-zinc-700 text-white focus:border-[#ff6a13] focus:ring-[#ff6a13]" placeholder="+1 555 000 0000" /></div>
          <div><Label className="text-zinc-300">Password</Label>
            <div className="relative mt-1.5">
              <Input data-testid="register-password" type={showPassword ? "text" : "password"} required minLength={6} value={form.password} onChange={set("password")} className="bg-[#1e222d] border-zinc-700 text-white focus:border-[#ff6a13] focus:ring-[#ff6a13] pr-11" />
              <button type="button" data-testid="toggle-password-visibility" onClick={() => setShowPassword((s) => !s)} aria-label={showPassword ? "Hide password" : "Show password"} className="absolute right-3 top-1/2 -translate-y-1/2 text-zinc-500 hover:text-white transition-colors">
                {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
              </button>
            </div></div>
          <Button data-testid="register-submit" disabled={loading} type="submit" className="w-full bg-[#ff6a13] hover:bg-[#ff8a3d] text-white rounded-full h-11 font-semibold">
            {loading ? "Creating…" : "Create Account"}
          </Button>
        </form>
        <div className="flex items-center gap-3 my-5"><div className="flex-1 h-px bg-zinc-800" /><span className="text-xs text-zinc-600 font-mono-p">OR</span><div className="flex-1 h-px bg-zinc-800" /></div>
        <Button data-testid="google-register-btn" onClick={loginWithGoogle} variant="outline" className="w-full rounded-full h-11 border-zinc-700 bg-white text-black hover:bg-zinc-200 font-semibold">Continue with Google</Button>
        <p className="text-sm text-zinc-500 mt-6 text-center">Have an account? <Link to="/login" className="text-[#ff6a13] hover:underline" data-testid="go-login">Sign in</Link></p>
      </div>
    </div>
  );
}
